export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  {
    documentType: 'pageHome',
  },
  {
    documentType: 'pageBlogPost',
  },
  {
    documentType: 'pageAdvertorial',
  },
];
